import location from './location';
import params from './params';

export function pinterestShare(link, mediaUrl, description) {
    link = (link && typeof link == "string")?encodeURIComponent(link):location();

    var url = 'http://pinterest.com/pin/create/button/?url='+ link;
    if(mediaUrl && typeof mediaUrl == "string")
    	url += '&media='+encodeURIComponent(mediaUrl);
    if(description && typeof description == "string")
    	url += '&description='+encodeURIComponent(description);

    window.open(url, 'pinterestWindow', params);
};

